module.exports = "/_next/static/images/tj-1d2689539b3f02ab3da9cc41f298d5b1.svg";